import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be986da8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","justify-content":"center"} }
const _hoisted_2 = { class: "text-center" }

import { ref, computed, watch } from 'vue';
import { format, parse, addYears, addMonths, getYear, setMonth } from 'date-fns';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'FormatMonth',
  setup(__props) {

const store = useStore();
const months = [
  { label: '1월', value: '01' },
  { label: '2월', value: '02' },
  { label: '3월', value: '03' },
  { label: '4월', value: '04' },
  { label: '5월', value: '05' },
  { label: '6월', value: '06' },
  { label: '7월', value: '07' },
  { label: '8월', value: '08' },
  { label: '9월', value: '09' },
  { label: '10월', value: '10' },
  { label: '11월', value: '11' },
  { label: '12월', value: '12' },
];

const currentDate = ref(parse(store.state.AdminYYMM || '2023-01', 'yyyy-MM', new Date()));
const currentMonthDisplay = computed(() => {
  return isNaN(currentDate.value.getTime()) ? '' : format(currentDate.value, "yyyy-MM");
});

const currentYear = computed(() => getYear(currentDate.value));
const currentMonth = computed(() => format(currentDate.value, 'MM'));

const previousMonth = () => {
  currentDate.value = addMonths(currentDate.value, -1);
  updateStore();
};

const nextMonth = () => {
  currentDate.value = addMonths(currentDate.value, 1);
  updateStore();
};

const previousYear = () => {
  currentDate.value = addYears(currentDate.value, -1);
  updateStore();
};

const nextYear = () => {
  currentDate.value = addYears(currentDate.value, 1);
  updateStore();
};

const selectMonth = (month: { value: string }) => {
  const monthIndex = parseInt(month.value, 10) - 1;
  currentDate.value = setMonth(currentDate.value, monthIndex);
  updateStore();
};

const updateStore = () => {
  store.commit('setAdminYYMM', format(currentDate.value, 'yyyy-MM'));
};

watch(
  () => store.state.AdminYYMM,
  (newValue) => {
    if (newValue) {
      const parsedNewDate = parse(newValue, "yyyy-MM", new Date());
      currentDate.value = parsedNewDate;
      updateStore();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_icon, {
      color: "#002e00",
      onClick: previousMonth,
      size: "48"
    }, {
      default: _withCtx(() => [
        _createTextVNode("mdi-chevron-left")
      ]),
      _: 1
    }),
    _createVNode(_component_v_menu, { "close-on-content-click": false }, {
      activator: _withCtx(({ props }) => [
        _createElementVNode("h2", _mergeProps({
          class: "pb-1",
          style: {"cursor":"pointer","color":"#333"}
        }, props), _toDisplayString(currentMonthDisplay.value), 17)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, { style: {"width":"300px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { style: {"display":"flex","align-items":"center","justify-content":"center"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "#002e00",
                  onClick: previousYear,
                  size: "48",
                  class: "pt-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-chevron-left")
                  ]),
                  _: 1
                }),
                _createElementVNode("h2", _hoisted_2, _toDisplayString(currentYear.value), 1),
                _createVNode(_component_v_icon, {
                  color: "#002e00",
                  onClick: nextYear,
                  size: "48",
                  class: "pt-1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-chevron-right")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  class: "pa-4",
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(months, (month) => {
                      return _createVNode(_component_v_col, {
                        key: month.value,
                        cols: "3",
                        class: "d-flex justify-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: _normalizeClass(["monthLabelBtn", {'btnBg': month.value === currentMonth.value, 'ma-1': true}]),
                            onClick: ($event: any) => (selectMonth(month)),
                            disabled: month.value === currentMonth.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(month.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick", "disabled"])
                        ]),
                        _: 2
                      }, 1024)
                    }), 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_icon, {
      color: "#002e00",
      onClick: nextMonth,
      size: "48"
    }, {
      default: _withCtx(() => [
        _createTextVNode("mdi-chevron-right")
      ]),
      _: 1
    })
  ]))
}
}

})